module.exports = __webpack_public_path__ + "img/B01_HQ05.0d7557ad.jpg";